import * as queryString from "query-string-object";
import baseRequest from "./baseReuqest";

export async function getAllSeries(page, per_page, order, order_by, filters = {}) {
    let url = '/api/series/all';
    const q = queryString.stringify({page, per_page, order, order_by, ...filters});
    if (q) {
        url += `?${q}`;
    }
    return baseRequest(url);
}

export function loadSerial(id) {
    let url = `/api/series/${id}/info`;
    return baseRequest(url);
}